import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, Observable, throwError } from 'rxjs';
import { LocalStorageClass } from '../helpers/local-storage-helper';
import { ToastService } from '../services/shared/toast.service';

export function errorInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
  router: Router,
  toast: ToastService
): Observable<HttpEvent<unknown>> {
  return next(request).pipe(
    catchError((error) => {
      if (error.status === 401) {
        LocalStorageClass.clearUserData();
        router.navigate(['login']);
      }

      if (error.status === 403) {
        window.location.reload();
      }

      const errorCode = error?.error?.errors?.[0]?.code;

      if (errorCode) toast.error(`errors.${errorCode}`);

      return throwError(() => error);
    })
  );
}
